import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	contractorClientsRestCrudThunksForBuyer,
	contractorClientsRestCrudThunksForSupplier,
} from '../../thunks/contractor_clients_thunks';
import { connect } from 'react-redux';
import { Button, Form, Input, message } from 'antd';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { nullSafeGet } from '../../utils/DataAccessUtils';

const FORM_NAME = 'subcontractor-edit-form';

const SubcontractorEditForm = ({ onSuccess, create, update, targetCollectionName, formData }) => {
	const [form] = Form.useForm();
	const formRef = useRef();
	const [loading, setLoading] = useState(false);

	const isUpdate = useMemo(() => nullSafeGet('id', formData), [formData]);
	const submitMethod = useMemo(() => (isUpdate ? update : create), [create, isUpdate, update]);

	const handleSubmit = useCallback(
		(values) => {
			const entity = {
				...(formData || {}),
				...values,
			};
			setLoading(true);
			submitMethod(entity, 'id', targetCollectionName)
				.then((record) => {
					message.success(`Subcontractor updated successfully!`);
					onSuccess(record);
				})
				.catch((err) => message.error(err))
				.finally((record) => {
					setLoading(false);
				});
		},
		[formData, isUpdate, submitMethod, targetCollectionName]
	);

	const initialValues = useMemo(
		() => ({
			...(formData || {}),
			isSupplier: true,
			isBuyer: false,
		}),
		[formData]
	);

	const formItemStyle = { width: 500 };

	return (
		<Form
			id={FORM_NAME}
			layout="vertical"
			requiredMark={false}
			initialValues={initialValues}
			onFinish={handleSubmit}
			form={form}
			ref={formRef}
		>
			<Form.Item
				name="name"
				label="Client Name"
				style={formItemStyle}
				rules={[
					{
						required: true,
						message: 'Please give your subcontractor a name.',
					},
				]}
			>
				<Input />
			</Form.Item>
			<Form.Item>
				<Button type={'primary'} onClick={() => form.submit()} loading={loading}>
					Update Subcontractor
				</Button>
			</Form.Item>
		</Form>
	);
};

const mapStateToProps = (state) => ({
	users: state.users,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	create: (entity, primaryKey, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? contractorClientsRestCrudThunksForSupplier.create(
						entity,
						primaryKey,
						targetCollectionName
				  )
				: contractorClientsRestCrudThunksForBuyer.create(entity, primaryKey, targetCollectionName)
		),
	update: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? contractorClientsRestCrudThunksForSupplier.update(entity)
				: contractorClientsRestCrudThunksForBuyer.update(entity)
		),
});

const ComponentWithoutUserType = connect(
	mapStateToProps,
	mapDispatchToProps
)(SubcontractorEditForm);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
